import { render, staticRenderFns } from "./AverageDurationBetweenSale.vue?vue&type=template&id=000b6c0c&"
import script from "./AverageDurationBetweenSale.vue?vue&type=script&lang=js&"
export * from "./AverageDurationBetweenSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports